export function maskValue(price) {
    return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function maskCpf(value) {
    return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export function maskCep(value) {
    return value
        .replace(/\D/g, '')
        .replace(/(\d{5})(\d)/, '$1-$2')
}

export function maskPhone(value) {
    return value
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .slice(0, 15);
}

export function onlyNumbersInput(value) {
    return value.replace(/\D/g, '');
}

export function maskDate(value) {
    return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .slice(0, 10);
}

export function maskDateTime(value) {
    const date = value.split('T')[0];
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
}

export const formatDateForApi = (dateOfBirth) => {
    const [day, month, year] = dateOfBirth.split('/');
    return `${year}-${month}-${day}`;
};
